import { Record, List } from 'immutable';

export const StoreMP = new Record({
  id: null,
  isNew: true,
  isPending: false,
  error: 0,
  items: new List(),
});
